export const IPC_LOGGER_CHANNEL = 'logger_channel';
